
export default function componentDidUpdateInitViewFromUrl(multiSceneComponent, props, prevProps) {
    if (props.urlParams.mms && props.multiScene.initialized) {
        if (
            (props.urlParams.mms !== prevProps.urlParams.mms) ||
            (props.multiScene.initialized !== prevProps.multiScene.initialized)
        ) {
            if (multiSceneComponent) {
                let values = props.urlParams.mms.split(';');
                let yaw = (props.urlParams.yaw * Math.PI / 180) || 0;
                let pitch = (props.urlParams.pitch * Math.PI / 180) || 0;
                if (values.length >= 2) {
                    multiSceneComponent.showPositionOnTrajectory(
                        values[0], values[1], null, null, null, yaw, pitch,
                        {
                            ...multiSceneComponent.getModeParams(props.multiScene.mode)
                        }
                    );
                }
            }
        }
    }
}
